export const userNavigation = [
    {
        name: 'Login',
        to: '/login',
        click: ''
    },
    {
        name: 'Sign Up',
        to: '/sign-up',
        click: ''
    }
]